// extracted by mini-css-extract-plugin
export default {"header":"UP","container":"VP","accordeonitem":"WP","itemsticky":"XP","itemopen":"YP","open":"ZP","productname":"aQ","productinfo":"bQ","flavorstext":"cQ","invalidlimit":"eQ","limit":"fQ","scrollUpAccordion":"gQ","wrapper":"hQ"};
    if(module.hot) {
      // 1713809678963
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  